export const PERSONALIZATION_COLUMN_WIDTHS = {
  markerPublic: 3,
  markerInternal: 5,
  number: 5,
  step: 10,
  category: 10,
  itemName: 10,
  color: 10,
  baseCost: 10,
  ownerPrice: 10,
  residentPrice: 12,
  minText: 10,
  maxText: 25,
} as const;

export const percentage = (value: number) => `${value}%`;

export function getDescriptionAndNotesWidth(
  useNumbers: boolean,
  showResidentPrice: boolean,
  showBaseCost: boolean,
  showOwnerPrice: boolean,
  isPublic?: boolean,
) {
  const fixedColumnsWidth =
    (isPublic
      ? PERSONALIZATION_COLUMN_WIDTHS.markerPublic
      : PERSONALIZATION_COLUMN_WIDTHS.markerInternal) +
    (useNumbers ? PERSONALIZATION_COLUMN_WIDTHS.number : 0) +
    (!isPublic ? PERSONALIZATION_COLUMN_WIDTHS.step : 0) +
    PERSONALIZATION_COLUMN_WIDTHS.category +
    PERSONALIZATION_COLUMN_WIDTHS.itemName +
    PERSONALIZATION_COLUMN_WIDTHS.color +
    (showBaseCost && !isPublic ? PERSONALIZATION_COLUMN_WIDTHS.baseCost : 0) +
    (showOwnerPrice && !isPublic
      ? PERSONALIZATION_COLUMN_WIDTHS.ownerPrice
      : 0) +
    (showResidentPrice && !isPublic
      ? PERSONALIZATION_COLUMN_WIDTHS.residentPrice
      : 0);

  return Math.max(
    PERSONALIZATION_COLUMN_WIDTHS.minText,
    Math.min(
      PERSONALIZATION_COLUMN_WIDTHS.maxText,
      (100 - fixedColumnsWidth) / 2,
    ),
  );
}
